import React, { useContext, FC } from 'react'
import { useIntl } from 'react-intl'
import { css } from '@emotion/css'
import {
  IconCaretLeft,
  expandFontTheme,
  theme
} from '@contrast-security-inc/design-system-foundations'
import { RouteContext } from '../route-provider'

const buttonStyles = css`
  display: flex;
  flex-shrink: 0;
  border: 1px solid ${theme.color.neutral40};
  background-color: ${theme.color.neutral30};
  order: -1;
  margin-right: 16px;
  border-radius: 4px;
  padding: 8px 16px 8px 8px;
  ${expandFontTheme(theme.font.body)};
`
interface Props {
  aggregationsToClear: string[]
}

export const BackToGroups: FC<Props> = ({ aggregationsToClear }) => {
  const intl = useIntl()
  const { isCurrentQueryParam, setQueryParameters } = useContext(RouteContext)
  const isViewingDrilldown = isCurrentQueryParam('drilldown', 'true')

  if (!isViewingDrilldown) {
    return null
  }

  const onClick = () => {
    setQueryParameters('vulns', buildParmeters(aggregationsToClear))
  }

  return (
    <button className={buttonStyles} onClick={onClick}>
      <IconCaretLeft />
      {intl.formatMessage({ id: 'description_vulnerabilities_backToVulnList' })}
    </button>
  )
}

// Takes user back to the main grid with "group by sink" enabled and all filters cleared
function buildParmeters(aggregationsToClear: string[]) {
  const parameterValueMap = new Map<string, string | null>()
  parameterValueMap.set('groupedBy', 'SINK')

  aggregationsToClear.push('drilldown')
  aggregationsToClear.forEach((clearable) =>
    parameterValueMap.set(clearable, null)
  )

  return parameterValueMap
}

BackToGroups.displayName = 'BackToGroups'
